<script setup lang="ts">
import { ref } from 'vue';

import David from '@/components/about-us/our-family/David.vue';
import Jeffrey from '@/components/about-us/our-family/Jeffrey.vue';
import Kenny from '@/components/about-us/our-family/Kenny.vue';
import Sandy from '@/components/about-us/our-family/Sandy.vue';
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import Header2 from '@/components/base/typography/Header2.vue';
import UnstyledButton from '@/components/base/UnstyledButton.vue';

const ourFamilySandyBw = nutshell['img/rasterized/our-family-sandy-bw@1x.png'];
const ourFamilySandy = nutshell['img/rasterized/our-family-sandy@1x.png'];
const ourFamilyDavidBw = nutshell['img/rasterized/our-family-david-bw@1x.png'];
const ourFamilyDavid = nutshell['img/rasterized/our-family-david@1x.png'];
const ourFamilyJeffBw = nutshell['img/rasterized/our-family-jeff-bw@1x.png'];
const ourFamilyJeff = nutshell['img/rasterized/our-family-jeff@1x.png'];
const ourFamilyKennyBw = nutshell['img/rasterized/our-family-kenny-bw@1x.png'];
const ourFamilyKenny = nutshell['img/rasterized/our-family-kenny@1x.png'];

type Family = 'sandy' | 'david' | 'jeffrey' | 'kenny';

const family = ref<Family>();
</script>

<template>
  <div class="ourFamilyContainer">
    <Header2>Our Nutty Family</Header2>
    <div class="mt-5">
      <BaseBodyText>
        As the second and third generation of this business, we live and breathe what we do here at
        Nuts.com. This business has survived the Great Depression, Poppy Sol going off to fight in
        World War II, our warehouse being firebombed in the Newark riots in 1967, and relocations by
        the city of Newark in both 1984 and 2005. Working side-by-side with family isn't always the
        easiest of things, but at the end of the day we are grateful to be together.
      </BaseBodyText>
      <div class="mt-4">
        <div class="text-center">
          <div class="font-bold text-center">Click a nut cartoon for each of our stories.</div>
          <div class="inline-block mt-4">
            <UnstyledButton data-test="about-us-sandy-button" @click="family = 'sandy'">
              <img
                alt="Sandy nuts"
                class="inline-block"
                :data-alt-src="ourFamilySandy"
                :src="ourFamilySandyBw"
              />
              <BaseBodyText class="mt-2 underline text-nuts-cyan-700">Sandy</BaseBodyText>
            </UnstyledButton>
          </div>
          <div class="inline-block mt-4">
            <UnstyledButton data-test="about-us-david-button" @click="family = 'david'">
              <img
                alt="David nuts"
                class="inline-block mt-4"
                :data-alt-src="ourFamilyDavid"
                :src="ourFamilyDavidBw"
              />
              <BaseBodyText class="mt-2 underline text-nuts-cyan-700">David</BaseBodyText>
            </UnstyledButton>
          </div>
          <div class="inline-block mt-4">
            <UnstyledButton data-test="about-us-jeffrey-button" @click="family = 'jeffrey'">
              <img
                alt="Jeffrey nuts"
                class="inline-block mt-4"
                :data-alt-src="ourFamilyJeff"
                :src="ourFamilyJeffBw"
              />
              <BaseBodyText class="mt-2 underline text-nuts-cyan-700">Jeffrey</BaseBodyText>
            </UnstyledButton>
          </div>
          <div class="inline-block mt-4">
            <UnstyledButton data-test="about-us-kenny-button" @click="family = 'kenny'">
              <img
                alt="Kenny nuts"
                class="inline-block mt-4"
                :data-alt-src="ourFamilyKenny"
                :src="ourFamilyKennyBw"
              />
              <BaseBodyText class="mt-2 underline text-nuts-cyan-700">Kenny</BaseBodyText>
            </UnstyledButton>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade" mode="out-in">
      <Sandy v-if="family === 'sandy'" class="flex flex-col gap-4 mt-4" />
      <David v-else-if="family === 'david'" class="flex flex-col gap-4 mt-4" />
      <Jeffrey v-else-if="family === 'jeffrey'" class="flex flex-col gap-4 mt-4" />
      <Kenny v-else-if="family === 'kenny'" class="flex flex-col gap-4 mt-4" />
    </transition>
  </div>
</template>
